import React, { useState } from "react";
import flag from "../../assets/images/website-images/arabic-lang-flag.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faChevronRight,
  faCommentDots,
  faGlobe,
  faLanguage,
} from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@store/store";
import { faComment } from "@fortawesome/free-regular-svg-icons";
import { IconButton } from "@mui/material";
import { ArrowLeft } from "lucide-react";
import { changeWebsiteLanguage } from "src/Store/reducer";

interface IProps {
  onClose: () => void;
}

const LanguageChangeModal: React.FC<IProps> = ({ onClose }) => {
  const { websiteLanguage } = useSelector(
    (state: RootState) => state.appReducer
  );
  const [activeChangeLanguage, setActiveChangeLanguage] = useState(false);
  const [activeChangeCountry, setActiveChangeCountry] = useState(false);

  const dispatch = useDispatch();

  let tabs: {
    label: string;
    flag?: JSX.Element;
    onClick: () => void;
    label2: string;
    icon: JSX.Element;
  }[] = [
    {
      label: "Country",
      flag: <img src={flag} alt="Flag" className="w-7" />,
      onClick: () => setActiveChangeCountry(true),
      label2: "UAE",
      icon: <FontAwesomeIcon icon={faGlobe} className="w-6 h-6" />,
    },
    {
      label: "Language",
      onClick: () => setActiveChangeLanguage(true),
      label2: websiteLanguage?.label,
      icon: <FontAwesomeIcon icon={faLanguage} className="w-6 h-6" />,
    },
  ];

  let languages = [
    {
      label: "Arabic",
      code: "ar",
    },
    {
      label: "English",
      code: "en",
    },
  ];

  const handleChangeLanguage = (lang: { label: string; code: string }) => {
    dispatch(changeWebsiteLanguage({ code: lang?.code, label: lang?.label }));
  };

  return (
    <div className="fixed top-0 left-0 w-screen h-screen z-20 bg-black/70 flex items-center justify-center" onClick={(e) => {
      if (e.target === e.currentTarget) {
        onClose();
      }
    }}>
      <div className="bg-white rounded-md shadow-md w-fit min-w-[350px]">
        <h2
          className={`font-size-18px font-Poppins-Medium text-[#2F2F31] min-h-[50px] flex gap-1 items-center pr-4 ${
            activeChangeLanguage ? "pl-1" : "pl-4"
          } border-b border-[#707070]`}
        >
          {activeChangeLanguage && (
            <IconButton onClick={() => setActiveChangeLanguage(false)}>
              <ArrowLeft />
            </IconButton>
          )}{" "}
          {activeChangeLanguage
            ? "Select A Language"
            : "Change Country Or Language"}
        </h2>

        {activeChangeLanguage && (
          <div className="px-1 py-3 flex flex-col gap-1">
            {languages?.map((item) => (
              <div
                key={item.label}
                className={`flex items-center justify-between gap-2 px-3 py-2 cursor-pointer ${
                  websiteLanguage?.code === item.code
                    ? "bg-[#F0FDF4]"
                    : "hover:bg-[#F0FDF4]"
                } rounded-md`}
                onClick={() => handleChangeLanguage(item)}
              >
                <div className="flex gap-2 items-center">
                  <div className="w-6 flex items-center justify-center">
                    <FontAwesomeIcon icon={faLanguage} className="w-6 h-6" />
                  </div>
                  <span className="font-Poppins-Regular font-size-18px text-[#2F2F31]">
                    {item.label}
                  </span>
                </div>
                {websiteLanguage?.code === item.code && (
                  <div className="flex w-5 h-5 bg-[#22C55E] rounded-full text-white justify-center items-center">
                    <FontAwesomeIcon icon={faCheck} className=" text-xs" />
                  </div>
                )}
              </div>
            ))}
          </div>
        )}

        {!activeChangeLanguage && !activeChangeCountry && (
          <div className="px-1 py-3 flex flex-col gap-1">
            {tabs?.map((item) => (
              <div
                key={item.label}
                className="flex items-center justify-between gap-2 px-3 py-2 cursor-pointer hover:bg-[#F0FDF4] rounded-md"
                onClick={item.onClick}
              >
                <div className="flex gap-2 items-center">
                  <div className="w-6 flex items-center justify-center">
                    {item.icon}
                  </div>
                  <span className="font-Poppins-Regular font-size-18px text-[#2F2F31]">
                    {item.label}
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  {item.flag}
                  <span className="font-Poppins-Regular font-size-18px text-[#2F2F31]">
                    {item.label2}
                  </span>
                  <FontAwesomeIcon
                    icon={faChevronRight}
                    className="text-gray-600 text-xs"
                  />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default LanguageChangeModal;
